import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { InformesService } from 'app/services/informes.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-beneficiario-cel',
  templateUrl: './beneficiario-cel.component.html',
  styleUrls: ['./beneficiario-cel.component.scss']
})
export class BeneficiarioCelComponent implements OnInit {

  public celular:string;

  constructor(@Inject(MAT_DIALOG_DATA) private datos, private _informe: InformesService, private dialog: MatDialogRef<BeneficiarioCelComponent>, private _snackBar: MatSnackBar) { }

  ngOnInit() {
    this.celular = this.datos.celular;
  }

  public guardarCelular(){

    let response:Object = {
      respuesta: true,
      indice: this.datos.indice,
      celular: this.celular
    }

    this.dialog.close(response);

    /* this._informe.ActualizarBenefCel(this.datos.beneficiario_doc, this.datos.celular).subscribe((data:any) => {
      this._snackBar.open('Se ha actulizado el teléfono del beneficiario', 'Aceptar', {
        duration: 2000
      });
      this.dialog.close(response);
    });
     */
  }

}
